module.exports = "<a :class=classes :style=style :href=id @mouseenter=onMouseEnter @mouseleave=onMouseLeave> {{ text }} </a> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/common/image-viewer/templates/image-viewer-marker.html
// module id = 18
// module chunks = 1 2